var _defs, _path, _path2, _path3, _path4, _path5, _text, _text2, _path6, _path7, _path8, _path9, _path10, _text3, _text4, _text5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCadisLogoVertical(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 303.85 187.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2e6b24;}.cls-2{font-size:22.64px;fill:#55669b;font-family:Calibri-Bold, Calibri;font-weight:700;}.cls-3{letter-spacing:-0.01em;}.cls-4{letter-spacing:-0.07em;}.cls-5{letter-spacing:-0.01em;}.cls-6{fill:#04165d;}.cls-7{font-size:9.59px;font-family:MyriadPro-Regular, Myriad Pro;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CADIS-Logo-vertical") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M583.15,375",
    transform: "translate(-429.86 -456.36)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M722.49,467.7",
    transform: "translate(-429.86 -456.36)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M728.43,476.5c-90.35-28.2-80.83-25.46-152.54,0",
    transform: "translate(-429.86 -456.36)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M638,429.78",
    transform: "translate(-429.86 -456.36)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M660.14,483.69H636.93c-7.45,0-13.5,5.73-13.5,12.79h0c0,7.07,6.05,12.8,13.5,12.8h23.21c7.46,0,13.5-5.73,13.5-12.8h0C673.64,489.42,667.6,483.69,660.14,483.69Zm-19.55,20.52a7.74,7.74,0,1,1,8.15-7.73A8,8,0,0,1,640.59,504.21Zm21.88-3.47c-1.21,0-2.18-1.91-2.18-4.26s1-4.25,2.18-4.25,2.17,1.91,2.17,4.25S663.67,500.74,662.47,500.74Z",
    transform: "translate(-429.86 -456.36)"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(154.61 180.05) scale(1.19 1)"
  }, "H", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 14.28,
    y: 0
  }, "E"), /*#__PURE__*/React.createElement("tspan", {
    x: 25.05,
    y: 0
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-4",
    x: 38.76,
    y: 0
  }, "L"), /*#__PURE__*/React.createElement("tspan", {
    x: 46.68,
    y: 0
  }, "THT"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 83.37,
    y: 0
  }, "E"), /*#__PURE__*/React.createElement("tspan", {
    x: 94.08,
    y: 0
  }, "CH "))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: -429.86,
    y: -456.36
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M457.93,594.29a24.16,24.16,0,0,1-11.17-2.63,28.06,28.06,0,0,1-8.9-7.21A33.59,33.59,0,0,1,432,573.6,42.52,42.52,0,0,1,429.86,560,41.16,41.16,0,0,1,432,546.54a30.79,30.79,0,0,1,5.89-10.39,26.19,26.19,0,0,1,20.07-9h31.33v11.73H457.93a16.07,16.07,0,0,0-7.19,1.62,17.17,17.17,0,0,0-5.69,4.48,21.45,21.45,0,0,0-3.74,6.84,27.08,27.08,0,0,0-1.35,8.77,27.65,27.65,0,0,0,1.35,8.77,21.86,21.86,0,0,0,3.74,7,17.44,17.44,0,0,0,5.69,4.57,15.71,15.71,0,0,0,7.19,1.66h31.33v11.73Z",
    transform: "translate(-429.86 -456.36)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M557.72,594.29l-8.66-16.9H521.7l4.77-9.51H544.2l-12.88-25.13-26.24,51.54H493.55L526.79,530a8.55,8.55,0,0,1,2.07-2.77,4.25,4.25,0,0,1,2.86-1,4.11,4.11,0,0,1,2.82,1,8.93,8.93,0,0,1,2,2.77l33.32,64.28Z",
    transform: "translate(-429.86 -456.36)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M576.09,594.29V527.14h33.48a26.5,26.5,0,0,1,11.29,2.41,26.11,26.11,0,0,1,8.9,6.74,31.84,31.84,0,0,1,5.85,10.39,40.44,40.44,0,0,1,2.1,13.34,42.52,42.52,0,0,1-2.1,13.58,34.1,34.1,0,0,1-5.85,10.85,27.63,27.63,0,0,1-8.9,7.21,24.59,24.59,0,0,1-11.29,2.63Zm33.48-11.73a15.74,15.74,0,0,0,7.19-1.66,17.91,17.91,0,0,0,5.73-4.57,21.34,21.34,0,0,0,3.77-7,27.65,27.65,0,0,0,1.36-8.77,27.26,27.26,0,0,0-1.36-8.73,20.83,20.83,0,0,0-3.77-6.88,17.63,17.63,0,0,0-5.73-4.48,16.1,16.1,0,0,0-7.19-1.62H586.11v43.69Z",
    transform: "translate(-429.86 -456.36)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M646.54,594.29V527.14h10.1v67.15Z",
    transform: "translate(-429.86 -456.36)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M667.21,594.29V582.56h43.34a8,8,0,0,0,6.24-2.4,9.08,9.08,0,0,0,2.19-6.37q0-4.35-2.19-6.51a8.47,8.47,0,0,0-6.24-2.17H684a18.15,18.15,0,0,1-7.35-1.44,15.61,15.61,0,0,1-5.57-4,17.81,17.81,0,0,1-3.5-6.05,23,23,0,0,1-1.23-7.66,23.68,23.68,0,0,1,1.15-7.53,16.48,16.48,0,0,1,3.42-6,15.88,15.88,0,0,1,5.61-3.92,19.09,19.09,0,0,1,7.63-1.44h41.51v11.73H684.15a6.85,6.85,0,0,0-5.41,2.17,8.89,8.89,0,0,0-1.91,6.05,8.57,8.57,0,0,0,1.95,6,6.81,6.81,0,0,0,5.29,2.12h26.48q8.82,0,13.4,4.8t4.57,14.6a26.55,26.55,0,0,1-1.11,7.85,17.69,17.69,0,0,1-3.34,6.23,15.15,15.15,0,0,1-5.61,4.11,19.52,19.52,0,0,1-7.91,1.48Z",
    transform: "translate(-429.86 -456.36)"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: -429.86,
    y: -456.36
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: -429.86,
    y: -456.36
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(160.55 162.23) scale(0.83 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    xmlSpace: "preserve"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCadisLogoVertical);
export default __webpack_public_path__ + "static/media/CadisLogoVertical.610cc3d93510df604aeee01ba862faa9.svg";
export { ForwardRef as ReactComponent };